export default __webpack_public_path__ + "b7339c6cd6242065de86b7a2b79f97d0.svg";